import { axios } from '@/services/axios';

const getTriggers = async (
    currentScope,
    currentCompany,
    currentPartner,
    currentWholesaler,
) => {
    const tableFetch = () => {
        switch (currentScope) {
            case 20:
                return '/triggers/list?companyID=' + currentCompany;
            case 40:
                return '/triggers/list?partnerID=' + currentPartner;
            case 60:
                return '/triggers/list?wholesalerID=' + currentWholesaler;
            default:
                return '/triggers/list';
        }
    };
    const res = await axios.get(tableFetch());
    return res.data;
};

export default getTriggers;
